import React from 'react'
import StarChartOrgItemDeletePresentation from '../../presentation/starChartOrg.item.delete.presentation/StarChartOrgItemDeletePresentation'
import { StarChartItemDeleteContainerProps } from '../../types/types'

const StarChartOrgItemDeleteContainer: React.FC<StarChartItemDeleteContainerProps> = ({starChartDelete , closeDeletePopup , starChartName}) => {

  return (
    <StarChartOrgItemDeletePresentation starChartDelete={starChartDelete} closeDeletePopup={closeDeletePopup} starChartName={starChartName}/>

  )
}

export default StarChartOrgItemDeleteContainer

